import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Card, Form, Image, Button, Modal, ListGroup } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { getItem, setItem } from '../../config/localStorage';
import UserImgTemp from '../../assets/image/user-img-temp.jpg';
import Stepper from '../../component/stepper/Stepper';
import ChangeTemplateLayout from '../../component/changetemplate/ChangeTemplateLayout';
import { axiosInstance, pythonAxiosInstance } from '../../config/ConfigInfo';
import SpinLoader from '../../component/loader/SpinLoader';
import { jwtDecode } from 'jwt-decode';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const Profile = () => {
    const storeLocalData = JSON.parse(getItem('profileData'));
    const storeLocalImage = getItem('profileImage');
    const [imageFile, setImageFile] = useState(storeLocalImage || '');
    const navigate = useNavigate();
    const locationPath = useLocation();

    const [firstName, setFirstName] = useState(storeLocalData?.firstName || '');
    const [lastName, setLastName] = useState(storeLocalData?.lastName || '');
    const [email, setEmail] = useState(storeLocalData?.email || '');
    const [phone, setPhone] = useState(storeLocalData?.phone || '');
    const [city, setCity] = useState(storeLocalData?.city || '');
    const [state, setState] = useState(storeLocalData?.state || '');
    const [country, setCountry] = useState(storeLocalData?.country || '');

    const [loader, setLoader] = useState(true);

    const [errorFirstName, setErrorFirstName] = useState('');
    const [errorLastName, setErrorLastName] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [errorPhone, setErrorPhone] = useState('');
    const [errorCity, setErrorCity] = useState('');
    const [errorState, setErrorState] = useState('');
    const [errorCountry, setErrorCountry] = useState('');

    const [errorImageFile, setErrorImageFile] = useState('')

    const [error, setError] = useState('');

    const [showProfileInfo, setShowProfileInfo] = useState(false);
    const [showProfileImage, setShowProfileImage] = useState(false);

    /** to handle next and previous click button start */
    useEffect(() => {
        if (locationPath.state === null) {
            navigate('/resume-builder');
        }
    }, [])
    /** to handle next and previous click button end */

    /**
     *  profile API call and set the response data in input fields
     */

    useEffect(() => {
        (async () => {
            if (getItem('profileData') === null) {
                try {
                    const userResponse = await axiosInstance.get("api/Account/GetUser");
                    if (userResponse.status === 200 && userResponse.data.success !== false) {
                        const userData = userResponse.data.data;
                        setFirstName(userData.firstName ?? '');
                        setLastName(userData.lastName ?? '');
                        setEmail(userData.email ?? '');
                        setPhone(userData.phoneNumber ?? '');
                        setCity(userData.city ?? '');
                        setState(userData.state ?? '');
                        setCountry(userData.country ?? '');
                    }
                    setLoader(false);
                }
                catch (error) {
                    setError(error.message);
                    setLoader(false);
                }
            }

            if (getItem('profileImage') === null) {
                try {
                    const imageResponse = await axiosInstance.get("api/Common/GetProfileImages");
                    if (imageResponse.status === 200 && imageResponse.data !== null) {
                        setImageFile(imageResponse.data.data[0].filePath);
                    }
                    setLoader(false);
                }
                catch (error) {
                    setError(error.message);
                    setLoader(false);
                }
            }

            setLoader(false);

        })();
    }, []);

    const handleUploadFile = async (e) => {
        const file = e.target.files[0];
        // Check the file type
        const allowedExtensions = ['.jpg', '.png', '.jpeg'];
        const fileExtension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
        setShowProfileImage(true);
        if (!allowedExtensions.includes(fileExtension)) {
            setErrorImageFile('Oops! Please select a valid JPG or PNG image.');
            setShowProfileImage(false);
        } else if (file.size > 1024 * 1024) { // less than 1mb image upload only 
            setErrorImageFile('Please choose an image that’s less than 1 MB!');
            setShowProfileImage(false);
        } else {
            const getUserId = jwtDecode(getItem('token'));
            const formData = new FormData();
            formData.append('resumeUserId', getUserId?.UserID || null);
            formData.append('image', file);

            try {
                const uploadImageRes = await pythonAxiosInstance.post("image-upload/", formData, {
                    headers: {
                        "Content-type": "application/file",
                    }
                });

                if (uploadImageRes.status === 200 && uploadImageRes.data.status === 'success') {
                    setImageFile(uploadImageRes.data.profile_image_url);
                    setItem('profileImage', uploadImageRes.data.profile_image_url);
                    setErrorImageFile('');
                    setShowProfileImage(false);
                } else {
                    setErrorImageFile(uploadImageRes.data.message);
                    setShowProfileImage(false);
                }
            }
            catch (e) {
                console.error('Error:', error);
                setShowProfileImage(false);
            }
        }
    }

    const handleFirstNameChange = (e) => {
        const newValue = e.target.value.replace(/[^a-zA-Z]/g, '');
        const regFirstName = /^[a-zA-Z]*$/;
        if (newValue.length === 0) {
            setErrorFirstName("Please enter the first name.");
        } else if (newValue.length >= 15) {
            setErrorFirstName("First name should be shorter than 15 characters.");
        } else {
            setErrorFirstName('');
        }
        if (!regFirstName.test(newValue)) {
            setErrorFirstName("Enter valid text.");
            return;
        }

        setFirstName(newValue.replace(/\s/g, ''));
    };

    const handleLastNameChange = (e) => {
        const newValue = e.target.value.replace(/[^a-zA-Z]/g, '');
        const regLastName = /^[a-zA-Z]*$/;
        if (newValue.length === 0) {
            setErrorLastName("Please enter the last name.");
        } else if (newValue.length >= 15) {
            setErrorLastName("Last name should be shorter than 15 characters.");
        } else {
            setErrorLastName('');
        }
        if (!regLastName.test(newValue)) {
            setErrorLastName("Enter valid text.");
            return;
        }
        setLastName(newValue.replace(/\s/g, ''));
    }

    const handleEmailChange = (e) => {
        const newValue = e.target.value;
        const regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (newValue.length === 0) {
            setErrorEmail("Please enter an email address.");
        } else if (!regEmail.test(newValue)) {
            setErrorEmail("Enter a valid email address.");
            setEmail(newValue.replace(/\s/g, ''));
        } else {
            setErrorEmail('');
        }
        setEmail(newValue.replace(/\s/g, ''));
    }

    const handlePhoneChange = (value, country) => {
        const phoneValue = value;
        const countryCode = country.dialCode;
        const checkLength = phoneValue.slice(countryCode.length,);
        if (checkLength.length === 0) {
            setErrorPhone("Please enter the phone number with country code.");
        } else if (checkLength.length < 10) {
            setErrorPhone("Please enter the correct phone number.");
        } else {
            setErrorPhone('');
        }
        setPhone(value)
    }

    const handleCityChange = (e) => {
        const newValue = e.target.value
        if (newValue.length === 0) {
            setErrorCity("Please enter city.");
        } else {
            setErrorCity('');
        }
        setCity(newValue)
    }
    const handleStateChange = (e) => {
        const newValue = e.target.value
        if (newValue.length === 0) {
            setErrorState("Please enter state.");
        } else {
            setErrorState('');
        }
        setState(newValue)
    }
    const handleCountryChange = (e) => {
        const newValue = e.target.value
        if (newValue.length === 0) {
            setErrorCountry("Please enter country.");
        } else {
            setErrorCountry('');
        }
        setCountry(newValue)
    }

    const dataToStore = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        city: city,
        state: state,
        country: country
    }

    const storeData = (data) => {
        try {
            const jsonData = JSON.stringify(data);
            setItem('profileData', jsonData);
            setItem('profileImage', imageFile);
        }
        catch (error) {
            console.log(error);
        }
    }

    const MoveExperiencePage = (e) => {
        e.preventDefault();
        let isNextValid = Object.values(dataToStore).some((val) => val == "");
        if(!isNextValid){
            navigate('/experience', { state: { experienceTabOne: true } });
            storeData(dataToStore);
        }
    }

    const BackResumeBuilderPage = () => {
        navigate('/resume-builder');
    }

    const errorObj = {
        errorFirstName, errorLastName, errorEmail, errorPhone, errorState, errorCity, errorCountry
    }
    let isValid = Object.values(errorObj).some((val) => val !== "");
    let isNextValid = Object.values(dataToStore).some((val) => val == "");

    return (
        <>
            <section className='main-section padding-top-bottom profile-main-section'>

                <Container>
                    <Row>
                        <Col md={12}>
                            <Card className='profile-card-option shadow border-0'>
                                <Stepper pagenumber='1' />
                                <Card.Body>
                                    <Card.Title>What's the best way for employers to contact you?</Card.Title>
                                    <Card.Text>We suggest including an email and phone number.</Card.Text>

                                    {
                                        loader ? <SpinLoader /> :
                                            <Form onSubmit={MoveExperiencePage}>
                                                <Col md={12} className='mt-5 mb-4'>
                                                    <Row>
                                                        <Col md={2} className='image-part'>
                                                            <div className="imagePreview">
                                                                {
                                                                    <Image src={imageFile ? imageFile : UserImgTemp} alt='user-img-temp' />
                                                                }
                                                            </div>
                                                            <Col className='profile_btn_info_sec'>
                                                                {
                                                                    showProfileImage ?
                                                                        <button className="btn my-previous-btn disabled" role="button" aria-disabled="true">Uploading Photo...</button>
                                                                        :
                                                                        <label className="btn my-previous-btn">
                                                                            Upload Photo
                                                                            <input
                                                                                type="file"
                                                                                name="selectedfile"
                                                                                className="uploadFile img d-none"
                                                                                onChange={handleUploadFile}
                                                                                accept=".jpg, .png, .jpeg"
                                                                            />
                                                                        </label>
                                                                }
                                                                <i className="fa fa-info-circle show-profile-info" aria-hidden="true" onClick={() => setShowProfileInfo(true)}></i>
                                                            </Col>
                                                            {

                                                                errorImageFile ? <p className='text-danger'>{errorImageFile}</p> : ''
                                                            }
                                                        </Col>
                                                        <Col md={8} className='form-mid-section'>

                                                            <Row>
                                                                <Col md={6}>
                                                                    <Form.Group className="mb-3 border-danger"

                                                                    >
                                                                        <Form.Label>First Name <span className="fa fa-star requierd-star"></span></Form.Label>
                                                                        <Form.Control size="lg" type="text" placeholder="Enter the first name"
                                                                            name='firstName'
                                                                            value={firstName}
                                                                            onChange={handleFirstNameChange}
                                                                        />
                                                                        {
                                                                            errorFirstName ? <span className='text-danger'>{errorFirstName}</span> : ''
                                                                        }
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Last Name <span className="fa fa-star requierd-star"></span></Form.Label>
                                                                        <Form.Control size="lg" type="text" placeholder="Enter the last name"
                                                                            name='lastName'
                                                                            value={lastName}
                                                                            onChange={handleLastNameChange}
                                                                        />
                                                                        {
                                                                            errorLastName ? <span className='text-danger'>{errorLastName}</span> : ''
                                                                        }
                                                                    </Form.Group>
                                                                </Col>

                                                                <Col md={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Email <span className="fa fa-star requierd-star"></span></Form.Label>
                                                                        <Form.Control size="lg" type="email" placeholder="Enter the email"
                                                                            name='email'
                                                                            value={email}
                                                                            onChange={handleEmailChange}
                                                                        />
                                                                        {
                                                                            errorEmail ? <span className='text-danger'>{errorEmail}</span> : ''
                                                                        }
                                                                    </Form.Group>
                                                                </Col>

                                                                <Col md={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Phone <span className="fa fa-star requierd-star"></span></Form.Label>
                                                                        <PhoneInput
                                                                            country={'us'}
                                                                            inputProps={{
                                                                                name: 'phone',
                                                                                required: true,
                                                                                autoFocus: false
                                                                            }}
                                                                            value={phone}
                                                                            onChange={handlePhoneChange}
                                                                        />
                                                                        {
                                                                            errorPhone ? <span className='text-danger'>{errorPhone}</span> : ''
                                                                        }
                                                                    </Form.Group>
                                                                </Col>

                                                                <Col md={6}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>City <span className="fa fa-star requierd-star"></span></Form.Label>
                                                                        <Form.Control size="lg" type="text" placeholder="Enter the city"
                                                                            name='city'
                                                                            value={city}
                                                                            onChange={handleCityChange}
                                                                        />
                                                                        {
                                                                            errorCity ? <span className='text-danger'>{errorCity}</span> : ''
                                                                        }
                                                                    </Form.Group>
                                                                </Col>

                                                                <Col md={6}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>State <span className="fa fa-star requierd-star"></span></Form.Label>
                                                                        <Form.Control size="lg" type="text" placeholder="Enter the state"
                                                                            name='state'
                                                                            value={state}
                                                                            onChange={handleStateChange}
                                                                        />
                                                                        {
                                                                            errorState ? <span className='text-danger'>{errorState}</span> : ''
                                                                        }
                                                                    </Form.Group>
                                                                </Col>

                                                                <Col md={6}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Country <span className="fa fa-star requierd-star"></span></Form.Label>
                                                                        <Form.Control size="lg" type="text" placeholder="Enter the country"
                                                                            name='country'
                                                                            value={country}
                                                                            onChange={handleCountryChange}
                                                                        />
                                                                        {
                                                                            errorCountry ? <span className='text-danger'>{errorCountry}</span> : ''
                                                                        }
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                        <Col md={2} className='template-part'>
                                                            <ChangeTemplateLayout />
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col className='next-prev-btn-section col-md-12'>
                                                    <Row>
                                                        <Col md={2}></Col>
                                                        <Col md={8} className='form-mid-section'>
                                                            <Button className='my-previous-btn float-start' onClick={BackResumeBuilderPage}>Back</Button>
                                                            {
                                                                isValid ?
                                                                    <Button className='my-next-btn button-green float-end' disabled={isValid} >Next</Button>
                                                                    :
                                                                    <Button type='submit' className='my-next-btn button-green float-end' disabled={isValid || isNextValid} >Next</Button>
                                                            }
                                                        </Col>
                                                        <Col md={2}></Col>
                                                    </Row>
                                                </Col>

                                            </Form>
                                    }

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ShowProfileInfoData
                    show={showProfileInfo}
                    onHide={() => setShowProfileInfo(false)}
                />
            </section>


        </>
    )
}

function ShowProfileInfoData(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Tips For Including an image on a resume
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='profile-tips-section'>
                    <p><strong>Pros:</strong></p>
                    <ol className='fw-bold'>
                        <li>Personal Touch</li>
                        <ul className="fw-normal">
                            <li>An image can make your resume more personal and help you stand out from other candidates, giving a face to the name and creating a more memorable impression.</li>
                        </ul>
                        <li>Professional Image</li>
                        <ul className="fw-normal">
                            <li>If you work in a field where appearance and personal branding are important (e.g., media, sales, hospitality), a professional photo can enhance your application by presenting you as polished and marketable.</li>
                        </ul>
                        <li>Immediate Connection</li>
                        <ul className="fw-normal">
                            <li>A photo can help establish an immediate connection and make it easier for the employer to remember you, especially if you have had a prior interaction, like a networking event.</li>
                        </ul>
                    </ol>
                </div>

                <div className='profile-tips-section'>
                    <p><strong>Cons:</strong></p>
                    <ol className='fw-bold'>
                        <li>Bias and Discrimination</li>
                        <ul className="fw-normal">
                            <li>Including a photo can unintentionally lead to bias or discrimination based on appearance, age, race, gender, or other factors. This could potentially affect your chances of being selected for an interview.</li>
                        </ul>
                        <li>ATS Compatibility</li>
                        <ul className="fw-normal">
                            <li>Many companies use applicant tracking systems (ATS) to screen resumes, and these systems may not process images well, potentially causing issues with your resume’s formatting or making it harder for the system to parse your information</li>
                        </ul>
                        <li>Focus on Content</li>
                        <ul className="fw-normal">
                            <li>A photo can distract from the content of your resume. Employers may spend more time looking at your picture rather than focusing on your skills, experience, and qualifications.</li>
                        </ul>
                        <li>Cultural Norms</li>
                        <ul className="fw-normal">
                            <li>In some countries, it is standard to include a photo on a resume, while in others, it is discouraged or even considered unprofessional. Understanding the cultural norms of the country you are applying in is important.</li>
                        </ul>
                    </ol>
                </div>

                <div className='profile-tips-section'>
                    <p><strong>Conclusion:</strong></p>
                    <p>Deciding whether to include an image on your resume depends on the industry, the job role, and cultural expectations. In general, unless it is specifically requested or common practice in your industry, it’s often safer to leave the image off and focus on presenting your qualifications and experience effectively.</p>
                </div>

            </Modal.Body>
        </Modal>
    );
}

export default Profile
